import { render, staticRenderFns } from "./QuiltyResourceGeneralView.vue?vue&type=template&id=79ce2d7b&"
import script from "./QuiltyResourceGeneralView.vue?vue&type=script&lang=ts&"
export * from "./QuiltyResourceGeneralView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79ce2d7b')) {
      api.createRecord('79ce2d7b', component.options)
    } else {
      api.reload('79ce2d7b', component.options)
    }
    module.hot.accept("./QuiltyResourceGeneralView.vue?vue&type=template&id=79ce2d7b&", function () {
      api.rerender('79ce2d7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/quiltyResources/QuiltyResourceGeneralView.vue"
export default component.exports